export default __webpack_public_path__ + "static/media/it.701531ff.svg";